module.exports = __webpack_public_path__ + "img/use_selected.3ecb77ae.svg";